import { render, staticRenderFns } from "./downMenu.vue?vue&type=template&id=296a31c0&scoped=true&"
import script from "./downMenu.vue?vue&type=script&lang=js&"
export * from "./downMenu.vue?vue&type=script&lang=js&"
import style0 from "./downMenu.vue?vue&type=style&index=0&id=296a31c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296a31c0",
  null
  
)

export default component.exports